export const tokens = {
  radius: { sm: 10, md: 18, lg: 26, pill: 999 },
  space: { xs: 4, sm: 8, md: 16, lg: 24, xl: 32, xxl: 48 },
  font: { body: 15, small: 12, title: 28, hero: 42 },
};
export const themes = {
  warm: {
    name: 'Light Mode',
    background: '#F2F2F7',
    surface: '#FFFFFF',
    surfaceAlt: '#E5E5EA',
    text: '#000000',
    muted: '#657069',
    border: '#D1D1D6',
    accent: '#A6192E',
    accentSoft: '#F9EBEB',
    onAccent: '#FFFFFF',
    success: '#34C759',
    successSoft: '#E8F8EE',
    warning: '#FF9500',
    warningSoft: '#FFF4E5',
    danger: '#FF3B30',
    overlay: '#00000033',
    hero: '#E5E5EA',
    heroInk: '#000000',
    shadow: '#000000',
    avatars: {
      coral: '#E5E5EA',
      sage: '#E5E5EA',
      lavender: '#E5E5EA',
      sand: '#E5E5EA',
      sky: '#E5E5EA',
    },
  },
  dark: {
    name: 'Dark Mode',
    background: '#000000',
    surface: '#1C1C1E',
    surfaceAlt: '#2C2C2E',
    text: '#FFFFFF',
    muted: '#9E9EA3',
    border: '#38383A',
    accent: '#E32636',
    accentSoft: '#3D1418',
    onAccent: '#FFFFFF',
    success: '#30D158',
    successSoft: '#1A2F21',
    warning: '#FF9F0A',
    warningSoft: '#33230A',
    danger: '#FF453A',
    overlay: '#000000B3',
    hero: '#1C1C1E',
    heroInk: '#FFFFFF',
    shadow: '#000000',
    avatars: {
      coral: '#2C2C2E',
      sage: '#2C2C2E',
      lavender: '#2C2C2E',
      sand: '#2C2C2E',
      sky: '#2C2C2E',
    },
  },
} as const;
export type ThemeName = keyof typeof themes;
export type Theme = (typeof themes)[ThemeName];
